import PropTypes from 'prop-types';

// @mui & other packages
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { Autocomplete, InputAdornment, Popper, TextField } from '@mui/material';
// components
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const PopperStyle = styled((props) => <Popper placement="bottom-start" {...props} />)({
  width: '280px !important',
});

// ----------------------------------------------------------------------

ResourcesSearch.propTypes = {
  resources: PropTypes.array.isRequired,
};

export default function ResourcesSearch({ resources }) {
  const { t } = useTranslation();

  return (
    <Autocomplete
      sx={{ width: 280 }}
      autoHighlight
      popupIcon={null}
      PopperComponent={PopperStyle}
      options={resources}
      getOptionLabel={(resource) => resource.title}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={`${t('Search')} ${t('Resources').toLowerCase()}...`}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon={'eva:search-fill'} sx={{ ml: 1, width: 20, height: 20, color: 'text.disabled' }} />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}
